export const environment = {
    production: false,
    msalConfig: {
      auth: {
        clientId: 'a236d933-6755-48c4-9e2a-df91aa15d68d',
        authority: 'https://login.microsoftonline.com/48d31cf0-95bf-4d84-887e-4eb7fe2d7753/',
      },
    },
    apiConfig: {
      scopes: ['user.read'],
      uri: 'https://rick-test.wwof.com/',
    },
  };